// extracted by mini-css-extract-plugin
export var buttons = "Z_cr";
export var container = "Z_b";
export var content = "Z_b8";
export var icon = "Z_bq";
export var iconContainer = "Z_dy";
export var image = "Z_g";
export var section = "Z_d";
export var selected = "Z_bg";
export var tab = "Z_ff";
export var tabText = "Z_fd";